export enum TableGridApiAction {
  SetTableApi = 'TABLE_GRID/SET_TABLE_API_STATE',
  SetInitialSelectedRows = 'TABLE_GRID/SET_INITIAL_ELECTED_ROWS',
  ResetSelectedRows = 'TABLE_GRID/RESET_SELECTED_ROWS',
  AddSelectedRows = 'TABLE_GRID/ADD_SELECTED_ROWS',
  RemoveSelectedRows = 'TABLE_GRID/REMOVE_SELECTED_ROWS',
  AddRowsAndIdsOrder = 'TABLE_GRID/ADD_ROWS_AND_IDS_ORDER',
}

export type TableGridApiActions =
  | {
      type: TableGridApiAction.SetTableApi;
      payload: {
        tableGridApi: TableGridApiState;
        rowSelectionIdGetter?: TableGridApiRowSelectionIdGetter;
      };
    }
  | {
      type: TableGridApiAction.SetInitialSelectedRows;
      payload: TableGridApiSelectedRowsState;
    }
  | { type: TableGridApiAction.ResetSelectedRows }
  | { type: TableGridApiAction.AddSelectedRows; payload: TableGridApiSelectedRowsState }
  | { type: TableGridApiAction.RemoveSelectedRows; payload: TableGridApiSelectedRowsState }
  | { type: TableGridApiAction.AddRowsAndIdsOrder; payload: TableGridApiRowsAndIdsOrder };

export type TableGridApiProps = {
  tableGridApi: TableGridApiState;
  selectedRows: TableGridApiSelectedRowsState;
  rowSelectionIdGetter?: TableGridApiRowSelectionIdGetter;
  rowsAndIdsOrder: TableGridApiRowsAndIdsOrder;
};

export type TableGridApiState = any;
export type TableGridApiSelectedRowsState = string[];
export type TableGridApiRowSelectionIdGetter = <T>(data: T) => string;
export type TableGridApiRowsAndIdsOrder = {};
export type TableGridApiProviderProps = { children: React.ReactNode };
